import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-resources-to-backend';

import translationEN from './en/common.json';
import translationRU from './ru/translationRU.json';
import translationUK from './uk/translationUK.json';
import translationTR from './tr/translationTR.json';
import translationESP from './esp/common.json';
import translationCN from './cn/translationCN.json';

const resources = {
  en: {
    translation: translationEN,
  },
  ru: {
    translation: translationRU,
  },
  uk: {
    translation: translationUK,
  },
  tr: {
    translation: translationTR,
  },
  es: {
    translation: translationESP,
  },
  cn: {
    translation: translationCN,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  i18n.init({
    debug: true, 
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['cookie', 'localStorage', 'path', 'htmlTag', 'subdomain'],
      caches: ['cookie'],
    },
    react: {
      useSuspense: false,
    },
  });
export default i18n;
